import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'm15.194 13.707 3.814 1.86-1.86 3.814', key: '16shm9' }],
  ['path', { d: 'M16.47214 7.52786 A 5 10 0 1 0 13 21.79796', key: '1245p8' }],
  ['path', { d: 'M21.79796 11 A 10 5 0 1 0 19 15.57071', key: '1i40ks' }],
];

/**
 * @component @name Rotate3d
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTUuMTk0IDEzLjcwNyAzLjgxNCAxLjg2LTEuODYgMy44MTQiIC8+CiAgPHBhdGggZD0iTTE2LjQ3MjE0IDcuNTI3ODYgQSA1IDEwIDAgMSAwIDEzIDIxLjc5Nzk2IiAvPgogIDxwYXRoIGQ9Ik0yMS43OTc5NiAxMSBBIDEwIDUgMCAxIDAgMTkgMTUuNTcwNzEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/rotate-3d
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Rotate3d = createLucideIcon('rotate-3d', __iconNode);

export default Rotate3d;
